(function () {
  setTimeout(iframe_injection_log_send_scrolltop_signal,3000);
  })();

  function iframe_injection_log_send_scrolltop_signal(){

    
var iframe = document.getElementById('iframe_injection_long');
  if (!iframe) return;

  // Visual badge so you KNOW it's running
 /*
  var badge = document.getElementById('sync-bar-parent-badge');
  if (!badge) {
    badge = document.createElement('div');
    badge.id = 'sync-bar-parent-badge';
    badge.style.position = 'fixed';
    badge.style.top = '8px';
    badge.style.right = '8px';
    badge.style.zIndex = '2147483647';
    badge.style.background = 'rgba(0,0,0,0.75)';
    badge.style.color = '#fff';
    badge.style.padding = '8px 10px';
    badge.style.borderRadius = '6px';
    badge.style.fontSize = '12px';
    badge.style.whiteSpace = 'pre';
    badge.style.pointerEvents = 'none';
    document.documentElement.appendChild(badge);
  }
*/
  console.log('[SYNC_BAR_PARENT] started');

  var lastSentKey = '';

  function tick() {
    var A = window.scrollY || document.documentElement.scrollTop || 0;
    var viewportH = window.innerHeight || document.documentElement.clientHeight || 0;
    var B = A + viewportH;

    var rect = iframe.getBoundingClientRect();
    var C = rect.top + A;

    // Only send if something changed
    var key = A + '|' + B + '|' + Math.round(C * 10) / 10;
    if (key !== lastSentKey) {
      lastSentKey = key;

      iframe.contentWindow.postMessage(
        { type: 'PARENT_VIEWPORT_SYNC', A: A, B: B, C: C },
        'https://go.ver.so'
      );

      console.log('[SYNC_BAR_PARENT] sent', { A: A, B: B, C: C, rectTop: rect.top, rectBottom: rect.bottom, viewportH: viewportH });
    }
/*
    badge.textContent =
      'SYNC_BAR_PARENT: RUNNING\n' +
      'A(scrollY): ' + A + '\n' +
      'B(viewportBottom): ' + B + '\n' +
      'C(iframeTopDocY): ' + (Math.round(C * 10) / 10) + '\n' +
      'iframeRect.top: ' + (Math.round(rect.top * 10) / 10) + '\n' +
      'iframeRect.bottom: ' + (Math.round(rect.bottom * 10) / 10) + '\n' +
      'viewportH: ' + viewportH;
*/
    requestAnimationFrame(tick);
  }

  requestAnimationFrame(tick);

  }